import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Rankings} from '../../types/rankings';

export type RankingSlice = {
  value: Rankings | null;
};

const initialState: RankingSlice = {
  value: null,
};

const rankingSlice = createSlice({
  name: 'rankingSlice',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Rankings>) => {
      state.value = action.payload;
    },

    reset: () => initialState,
  },
});

export const {set, reset} = rankingSlice.actions;
export default rankingSlice.reducer;
